import { global } from "../../constants";

export const data = {
  
    banner: {
    base: "Services",
    background: global.banner + "administrative-processes.webp",
    title: "Administrative Processes",
    crumb: "Administrative Processes",
  },

  icon: "fa-solid fa-clipboard-list",
  shortDescription:
    "Design, control, and execution of essential administrative processes for Ship-to-Ship (STS) operations, ensuring safety, efficiency, and regulatory compliance in accordance with OCIMF standards.",
  title: "Administrative Processes",
  features: {
    title: "Key Administrative Processes in STS Services",
    deliverables: "Deliverables",
    reqDocuments: "Required Documents",
    subtitle:
      "Planning, organization, direction, and control integrated into operational management and international compliance for ship-to-ship (STS) transfer operations.",
    description: `STS services require a robust administrative system that combines logistical efficiency with international compliance (OCIMF/ISGOTT). Our methodology is based on six key processes that ensure operational continuity, risk mitigation, and document traceability in every maneuver.`,
    viewDetail: "View Details",
    feats: [
      {
        key: "planificacion_logistica",
        title: "Plan Operational and Logistical Capacity",
        summary:
          "Strategic evaluation and planning of human, technical, and material resources to ensure availability and safety in every STS operation.",
        details:
          "We develop capacity plans that include the assignment of support vessels, fenders, hoses, and contingency equipment. This covers risk analysis by transfer zone, meteorological studies, review of port authorizations, and rest and availability planning for the POAC/Mooring Master. Due diligence of locations and contractors is incorporated to ensure compliance and efficiency.",
        deliverables: [
          "STS operational capacity plan",
          "Location and equipment risk assessment",
          "Critical human resources availability report"
        ],
        requiredDocs: [
          "Master STS operations plan",
          "Equipment and vessel certificates",
          "Personnel availability and rotation records"
        ],
        icon: "fa-solid fa-anchor",
        image: global.services + "administrative_processes/1.webp",
      },
      {
        key: "organizacion_rrhh",
        title: "Organize and Formalize Specialized Human Resources",
        summary:
          "Clear hierarchical structure and professional management of maritime and emergency talent to ensure operational coordination.",
        details:
          "We design functional organizational charts that define responsibilities in the STS chain: POAC, captains, safety officers, operators, and crisis teams. Human resources management (HRM) includes verification of STCW certificates, expiration control, maneuver experience records, and a recurrent training plan. The goal is to ensure competence, traceability, and incident response.",
        deliverables: [
          "Structure and authority delegation manual",
          "STCW certification and POAC experience record",
          "Annual training and drill plan"
        ],
        requiredDocs: [
          "Key personnel certificates",
          "Previous operations logs",
          "Training and evaluation records"
        ],
        icon: "fa-solid fa-users-gear",
        image: global.services + "administrative_processes/2.webp",
      },
      {
        key: "control_normativo",
        title: "Control Regulatory Compliance and Documentation",
        summary:
          "Comprehensive document audit prior to each STS operation to ensure compliance with maritime and safety regulations.",
        details:
          "We implement document management units that validate certificates for vessels, crew, and cargo (MSDS, COA, DOC, SMC, ISM, etc.). A digital audit is performed before departure, ensuring traceability, consistency, and compliance with OCIMF/ISGOTT guidelines. This control reduces the risk of sanctions, rejections, or operational delays.",
        deliverables: [
          "STS document checklist (pre-operation)",
          "Digital regulatory compliance audit",
          "Version control and traceability system"
        ],
        requiredDocs: [
          "Vessel and crew certificates",
          "Cargo safety documents (MSDS)",
          "ISM/ISPS manuals and records"
        ],
        icon: "fa-solid fa-file-shield",
        image: global.services + "administrative_processes/3.webp",
      },
      {
        key: "direccion_operacional",
        title: "Direct Operational and Safety Execution",
        summary:
          "Real-time coordination between POAC and captains to ensure safe execution of the Joint Operational Plan.",
        details:
          "During the STS maneuver, official OCIMF checklists are applied as control and validation tools. Direction includes effective communication between vessels, weather monitoring, verification of pressure/flow parameters, and the authority to suspend operations under unsafe conditions (wind, waves, leaks, or spills).",
        deliverables: [
          "Joint STS operations plan",
          "Execution reports with POAC observations",
          "Checklist and meteorological condition records"
        ],
        requiredDocs: [
          "Approved operations plan",
          "Current OCIMF/STS checklist",
          "POAC logbook and communication reports"
        ],
        icon: "fa-solid fa-compass-drafting",
        image: global.services + "administrative_processes/4.webp",
      },
      {
        key: "emergencias_contingencias",
        title: "Manage Emergency and Contingency Response",
        summary:
          "Formalized protocols for immediate response to maritime incidents, spills, or emergency situations in STS operations.",
        details:
          "We develop and train contingency plans (SOPEP, VRP) with hierarchical activation and immediate communication with maritime authorities. This includes cooperation agreements with the Navy, insurers, and emergency response companies. Regular drills strengthen personnel preparedness and the efficiency of emergency procedures.",
        deliverables: [
          "STS emergency response plan (SOPEP/VRP)",
          "Communication and command chain manual",
          "Drill and evaluation records"
        ],
        requiredDocs: [
          "Current SOPEP/VRP plan",
          "Contracts with response entities",
          "Contact lists and emergency protocols"
        ],
        icon: "fa-solid fa-triangle-exclamation",
        image: global.services + "administrative_processes/5.webp",
      },
      {
        key: "auditoria_mejora",
        title: "Audit Continuous Improvement and Financial Management",
        summary:
          "Annual monitoring of operational and financial performance, integrating quality control, costs, and regulatory compliance.",
        details:
          "We implement performance audits and annual reviews of STS procedures according to OCIMF guidelines. Financially, we review accounting transparency, safety, maintenance, and insurance costs, integrating them into an ERP system. This allows us to identify opportunities for continuous improvement and justify investment in compliance as mitigation of operational risk.",
        deliverables: [
          "Annual operational performance report",
          "STS financial and compliance audit",
          "Continuous improvement action plan"
        ],
        requiredDocs: [
          "STS accounting and cost records",
          "Incident or findings history",
          "Previous OCIMF or internal audits"
        ],
        icon: "fa-solid fa-chart-line",
        image: global.services + "administrative_processes/6.webp",
      },
    ],
  },
  ctaText: "Request STS process consulting",
  ctaLink: "/contact?service=administrative-processes-sts",
};